import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import { services } from '../data/services';
import './Services.css';

const Services = ({ limit, eyebrow = 'What we do', title, lead, showAllLink = true }) => {
  const list = limit ? services.slice(0, limit) : services;

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">{eyebrow}</span>
          <h2 className="section-title section-title--center">
            {title || (
              <>
                One studio for the whole stack — <span className="gradient-text">design, build, grow</span>.
              </>
            )}
          </h2>
          <p className="section-lead section-lead--center">
            {lead ||
              "From your first website to the IoT dashboard, mobile app and the SEO engine that fills your pipeline — we run the entire stack so you don't juggle five vendors."}
          </p>
        </div>

        <div className="services-grid">
          {list.map((s) => {
            const Icon = s.icon;
            return (
              <article key={s.slug} className="service-card card" style={{ '--svc-accent': s.accent }}>
                <div className="service-icon"><Icon /></div>
                <h3 className="service-title" dangerouslySetInnerHTML={{ __html: s.title }} />
                <p className="service-desc">{s.short}</p>
                <ul className="service-tags">
                  {s.tags.map((t) => <li key={t}>{t}</li>)}
                </ul>
                <Link to={`/services#${s.slug}`} className="service-link">
                  Learn more <FiArrowUpRight />
                </Link>
              </article>
            );
          })}
        </div>

        {showAllLink && limit && (
          <div className="services-foot">
            <Link to="/services" className="btn btn-ghost">
              See all services <FiArrowUpRight />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
